'use client';

import DisaHero from '@/components/DisaHero';
import { Fragment } from 'react';
import Heading from '../../../textContent/frappeHR/Header.json';
import VideoTextCard from '@/components/VideoTextCard';
import card1Data from '../../../textContent/frappeHR/card1Data.json';
import card2Data from '../../../textContent/frappeHR/card2Data.json';
import card3Data from '../../../textContent/frappeHR/card3Data.json';
import card4Data from '../../../textContent/frappeHR/card4Data.json';
import { motion } from 'framer-motion';

/* ---------------- Animation Variants ---------------- */

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut',
        },
    },
};

const page = () => {
    return (
        <Fragment>
            {/* Hero Animation */}
            <motion.div variants={fadeUp} initial="hidden" animate="visible">
                <DisaHero {...Heading.heroTextContent} />
            </motion.div>

            {/* Card 1 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={card1Data} />
            </motion.div>

            {/* Card 2 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={card2Data} />
            </motion.div>

            {/* Card 3 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={card3Data} />
            </motion.div>
            {/* Card 4 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="px-5 py-2 md:flex md:items-center md:justify-center md:px-[12vw] md:mb-5"
            >
                <VideoTextCard data={card4Data} />
            </motion.div>
        </Fragment>
    );
};

export default page;
